<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="10">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_label_placeholder') ||
                  '产品SKU编号/SKU名称/SKU品牌/NC物料编码/工厂/店铺/市场/市场/售卖标题/亚马逊SKU/店铺品牌/运营人员 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-info"
              @click="$emit('putShelves')"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('btn_putShelves') || '上架' }}
            </b-button>
            <el-badge :value="checkedCount" class="ml-2" v-if="allow('N')">
              <b-button
                size="sm"
                variant="outline-warning"
                @click="$emit('unsaleable')"
                :disabled="!checkedCount"
              >
                <b-icon-archive></b-icon-archive>
                {{ $l('btn_unsaleable') || '不可售' }}
              </b-button>
            </el-badge>
            <el-badge :value="checkedCount" class="ml-2" v-if="allow('S')">
              <b-button
                size="sm"
                variant="outline-success"
                @click="$emit('availableSale')"
                :disabled="!checkedCount"
              >
                <b-icon-archive-fill></b-icon-archive-fill>
                {{ $l('btn_availableSale') || '可售' }}
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      top="10vh"
      width="900px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_operate') || '运营人员'">
              <dict-select
                v-model="form.listOperateCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_advanced_placeholder_operate') || '请选择运营人员'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_platformCode') || '渠道'">
              <dict-select
                v-model="form.listPlatformCode"
                url="/ecom/evg/platform/select"
                :placeholder="$l('form_advanced_placeholder_platformCode') || '请选择渠道'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_region') || '市场'">
              <dict-select
                v-model="form.listRegionCode"
                :body="{ dictType: 'region' }"
                url="/master/common/dict/biz"
                :options="{ label: 'value', value: 'value' }"
                :placeholder="$l('form_advanced_placeholder_region') || '请选择市场'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_evgSkuNo') || '产品SKU编号'">
              <el-input
                v-model.trim="form.evgSkuNo"
                :placeholder="
                  $l('form_advanced_placeholder_evgSkuNo') || '请输入产品SKU编号'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_channelItemNo') || '渠道Item号'">
              <el-input
                v-model.trim="form.channelItemNo"
                :placeholder="$l('form_advanced_placeholder_channelItemNo') || '请输入渠道Item号'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_channelSkuNo') || '渠道款号'">
              <el-input
                v-model.trim="form.channelSkuNo"
                :placeholder="$l('form_advanced_placeholder_channelSkuNo') || '请输入渠道款号'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_channelEanNo') || '渠道条码号'">
              <el-input
                v-model.trim="form.channelEanNo"
                :placeholder="$l('form_advanced_placeholder_channelEanNo') || '请输入渠道条码号'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_goodsName') || 'SKU名称'">
              <el-input
                v-model.trim="form.goodsName"
                :placeholder="
                  $l('form_advanced_placeholder_goodsName') || '请输入SKU名称'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_brand') || 'SKU品牌'">
              <dict-select
                v-model="form.listBrandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="$l('form_advanced_placeholder_brand') || '请选择SKU品牌'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_ncNo') || 'NC物料编码'">
              <el-input
                v-model.trim="form.ncNo"
                :placeholder="$l('form_advanced_placeholder_ncNo') || '请输入NC物料编码'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_scm') || '工厂'">
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/scmPartners"
                :placeholder="$l('form_advanced_placeholder_scm') || '请选择工厂'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_advanced_label_platformBrandName') || '渠道品牌'">
              <dict-select
                v-model="form.listPlatformBrandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="
                  $l('form_advanced_placeholder_platformBrandName') || '请选择渠道品牌'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_advanced_label_platformStatus') || '售卖状态'"
            >
              <dict-select
                v-model="form.listPlatformStatus"
                :body="{ dictType: 'evgSkuPlatformStatus' }"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('form_advanced_placeholder_platformStatus') || '请选择售卖状态'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-row :gutter="5">
              <el-form-item :label="$l('form_advanced_label_salesPrice') || '售卖价格'">
                <br />
                <el-col :span="8">
                  <el-input-number
                    v-model="form.salesPriceStart"
                    :placeholder="
                      $l('form_advanced_placeholder_salesPriceStart') || '请输入售卖价格'
                    "
                    controls-position="right"
                    size="mini"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    v-model="form.salesPriceEnd"
                    :placeholder="
                      $l('form_advanced_placeholder_salesPriceEnd') || '请输入售卖价格'
                    "
                    controls-position="right"
                    style="width: 100%"
                    size="mini"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <dict-select
                    v-model="form.salesCurrencyUnit"
                    url="/master/common/dict/biz"
                    :body="{ dictType: 'currencyUnit' }"
                    :placeholder="$l('form_advanced_placeholder_salesCurrencyUnit') || '请选择货币单位'"
                    filterable
                    clearable
                    size="mini"
                    style="width:100%"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_advanced_label_salesTitle') || '售卖标题'">
              <el-input
                v-model.trim="form.salesTitle"
                :placeholder="
                  $l('form_advanced_placeholder_salesTitle') || '请输入售卖标题'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '' }
export default {
  props: { checkedCount: { type: Number, default: 0 } },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      masterCategoryParams: { parentCode: 'ABSHome' }
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
